import React, { useEffect, useMemo, useState } from 'react';

import { DataGrid } from '@mui/x-data-grid';
import { Box } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { CustomPagination, SingleAutocomplete } from 'common/components';

import {
    getFilteredPeriodsByYear,
    getUniqueYearsFromPeriods,
} from '../helpers';

const dataGridSx = {
    '& .MuiDataGrid-columnHeaderTitle': {
        lineHeight: 1,
        textAlign: 'center',
        textOverflow: 'clip',
        whiteSpace: 'break-spaces',
    },
    '& .MuiDataGrid-cell:focus': { outline: 'none' },
};

const HistoricalDataGrid = ({ columns, dateFields, isLoading, rows }) => {
    const [filteredPeriods, setFilteredPeriods] = useState([]);
    const { t } = useTranslation();

    useEffect(() => setFilteredPeriods(rows), [rows]);

    const yearsOptions = useMemo(
        () => getUniqueYearsFromPeriods(rows, dateFields),
        [dateFields, rows],
    );

    const handleOnChangeYear = (option) =>
        setFilteredPeriods(
            getFilteredPeriodsByYear(rows, dateFields, option?.value),
        );

    const getRowHeight = () => 'auto';
    const initialState = { pagination: { paginationModel: { pageSize: 12 } } };
    const slotProps = { pagination: { pageSizeOptions: [12] } };
    const slots = { pagination: CustomPagination };

    return (
        <>
            {yearsOptions?.length > 1 && (
                <Box mb={2}>
                    <SingleAutocomplete
                        disabled={isLoading}
                        fullWidth
                        isLoading={isLoading}
                        label={t('Year')}
                        onChange={handleOnChangeYear}
                        options={[{ label: '', options: yearsOptions }]}
                    />
                </Box>
            )}

            <DataGrid
                columns={columns}
                disableColumnMenu
                disableRowSelectionOnClick
                getRowHeight={getRowHeight}
                initialState={initialState}
                loading={isLoading}
                rows={filteredPeriods}
                slotProps={slotProps}
                slots={slots}
                sx={dataGridSx}
            />
        </>
    );
};

HistoricalDataGrid.propTypes = {
    columns: PropTypes.array,
    dateFields: PropTypes.array,
    isLoading: PropTypes.bool,
    rows: PropTypes.array,
};

export default HistoricalDataGrid;
